module.exports = __webpack_public_path__ + "static/media/sprite1-w.db7115f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/sprite1-w.png
// module id = 494
// module chunks = 0